export enum SegmentClientEvent {
  newsletterSubscribed = "Newsletter Subscribed",
  trialStarted = "Trial Started",
  subscriptionStarted = "Subscription Started",
  refereredArticleEmailCapture = "Referred Article Email Capture",
}

export enum SegmentServerEvent {
  newsletterSubscribed = "Newsletter Subscribed - Server",
  trialStarted = "Trial Started - Server",
  subscriptionStarted = "Subscription Started - Server",
  subscriptionPaid = "Subscription Paid - Server",
  subscriptionRenewed = "Subscription Renewed - Server",
}

export const SegmentEventMap = {
  [SegmentClientEvent.newsletterSubscribed]: "63902",
  [SegmentServerEvent.newsletterSubscribed]: "63902",
  [SegmentClientEvent.refereredArticleEmailCapture]: "15934",
  [SegmentClientEvent.trialStarted]: "78363",
  [SegmentServerEvent.trialStarted]: "78363",
  [SegmentClientEvent.subscriptionStarted]: "87193",
  [SegmentServerEvent.subscriptionStarted]: "87193",
};

export const getSegmentEventIDForSubscription = (
  event: SegmentClientEvent | SegmentServerEvent,
  subscriptionId: string
): string => {
  const reformattedSubscriptionId = subscriptionId.replace("_", "-");
  return `${SegmentEventMap[event]}-${reformattedSubscriptionId}`;
};

export const getSegmentEventIDForSubscriber = (
  event: SegmentClientEvent | SegmentServerEvent,
  subscriberId: string
): string => {
  return `${SegmentEventMap[event]}-${subscriberId}`;
};
